// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3w6wn","header":"Messages_header__2QQKv"};